import React, { useState, useEffect } from 'react';
import api from '../api';
import RightSidebar from './RightSidebar';
import MaintenanceRequestForm from './MaintenanceRequestForm';

const MaintenanceTable = ({ requests, onAddRequest }) => (
  <div className="bg-white dark:bg-gray-800 shadow-xl rounded-2xl p-8">
    <div className="flex justify-between items-center mb-6">
      <div>
        <h2 className="text-3xl font-bold text-gray-800 dark:text-white">
          Maintenance Requests
        </h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Track and manage vehicle maintenance and replacements.
        </p>
      </div>
      <button
        onClick={onAddRequest}
        className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-200"
      >
        New Request
      </button>
    </div>
    <div className="overflow-x-auto">
      <table className="min-w-full leading-normal">
        <thead>
          <tr className="bg-gray-50 dark:bg-gray-700">
            <th className="px-6 py-4 border-b-2 border-gray-200 dark:border-gray-600 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
              Vehicle No
            </th>
            <th className="px-6 py-4 border-b-2 border-gray-200 dark:border-gray-600 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
              Request Type
            </th>
            <th className="px-6 py-4 border-b-2 border-gray-200 dark:border-gray-600 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
              Status
            </th>
            <th className="px-6 py-4 border-b-2 border-gray-200 dark:border-gray-600 text-left text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
              Reported On
            </th>
          </tr>
        </thead>
        <tbody>
          {requests.map((request) => (
            <tr
              key={request.id}
              className="hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
            >
              <td className="px-6 py-5 border-b border-gray-200 dark:border-gray-600 text-sm">
                <p className="text-gray-900 dark:text-white whitespace-no-wrap font-medium">
                  {request.vehicle_no}
                </p>
              </td>
              <td className="px-6 py-5 border-b border-gray-200 dark:border-gray-600 text-sm">
                <p className="text-gray-900 dark:text-white whitespace-no-wrap">
                  {request.request_type}
                </p>
              </td>
              <td className="px-6 py-5 border-b border-gray-200 dark:border-gray-600 text-sm">
                <p className="text-gray-900 dark:text-white whitespace-no-wrap">
                  {request.status}
                </p>
              </td>
              <td className="px-6 py-5 border-b border-gray-200 dark:border-gray-600 text-sm">
                <p className="text-gray-900 dark:text-white whitespace-no-wrap">
                  {new Date(request.reported_on).toLocaleDateString()}
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const MaintenanceView = () => {
  const [requests, setRequests] = useState([]);
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const fetchRequests = async () => {
    try {
      const response = await api.get('/maintenance-requests');
      setRequests(response.data);
    } catch (error) {
      console.error('Error fetching maintenance requests:', error);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleRequestAdded = () => {
    setSidebarOpen(false);
    fetchRequests();
  };

  return (
    <div className="h-full">
      <MaintenanceTable
        requests={requests}
        onAddRequest={() => setSidebarOpen(true)}
      />
      <RightSidebar
        isOpen={isSidebarOpen}
        onClose={() => setSidebarOpen(false)}
      >
        <MaintenanceRequestForm onRequestAdded={handleRequestAdded} />
      </RightSidebar>
    </div>
  );
};

export default MaintenanceView;
